import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
const styles = theme => ({
    root: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        flexGrow: 1,
    },
    noPadding: {
        padding: 0,
    },
});

const useStyles = makeStyles()(styles);

const PortletContent = props => {
    const { BoxProps = {}, className, children, noPadding, ...rest } = props;
    const { classes, cx } = useStyles(undefined, {
        props,
    });
    const rootClassName = cx(
        {
            [classes.root]: true,
            [classes.noPadding]: noPadding,
        },
        className
    );

    return (
        <Box {...BoxProps} {...rest} className={rootClassName}>
            {children}
        </Box>
    );
};

PortletContent.propTypes = {
    BoxProps: PropTypes.object,
    children: PropTypes.node,
    className: PropTypes.string,
    noPadding: PropTypes.bool,
};

export default PortletContent;
